import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router-dom";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import Badge from "components/base/Badge";
import { format } from "date-fns";

export interface GrupoTableType {
  id: number;
  codigo: string;
  descricao: string;
  isDeleted?: boolean;
  deletedAt?: string;
}

export const grupoTableColumns: ColumnDef<GrupoTableType>[] = [
  {
    accessorKey: "codigo",
    header: "Código",
    cell: ({ getValue, row: { original } }) => {
      const codigo = getValue() as string;
      const { isDeleted } = original;
      return <span className={`${isDeleted ? 'text-muted' : ''}`}>{codigo}</span>;
    },
    meta: {
      headerProps: { style: { width: 80 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "descricao",
    header: "Grupo",
    meta: {
      headerProps: { style: { width: 250 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
    cell: ({ row }) => {
      const data = row.original;
      return (
        <div className="d-flex align-items-center">
          <Link
            to={`/cadastros/grupos/${data.id}`}
            className={`fw-semibold ${data.isDeleted ? 'text-decoration-line-through text-muted' : ''}`}
          >
            {data.descricao}
          </Link>
          {data.isDeleted && data.deletedAt && (
            <div className="small text-danger-emphasis ms-2">
              Excluído em {format(new Date(data.deletedAt), 'dd/MM/yyyy HH:mm')}
            </div>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row: { original } }) => {
      const { isDeleted } = original;

      if (isDeleted) {
        return <Badge bg="danger" className="badge-subtle rounded-pill">Excluído</Badge>;
      }

      return <Badge bg="success" className="badge-subtle rounded-pill">Ativo</Badge>;
    },
  },
];

const GruposTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default GruposTable;
